import arrayParser from "./Story Helpers/arrayParser";
import weightLossProcessor from "./Story Helpers/non standard element processors/weightLossProcessor";
import jaundiceProcessor from "./Story Helpers/non standard element processors/jaundiceProcessor";
import cobhProcessor from "./Story Helpers/non standard element processors/cobhProcessor";
import testisProcessor from "./Story Helpers/non standard element processors/testisProcessor";
import smokingProcessor from "./Story Helpers/non standard element processors/smokingProcessor";
import asbestosProcessor from "./Story Helpers/non standard element processors/asbestosProcessor";
import sobProcessor from "./Story Helpers/non standard element processors/sobProcessor";
import chestExaminationProcessor from "./Story Helpers/non standard element processors/chestExaminationProcessor";
import nippleRetractionProcessor from "./Story Helpers/non standard element processors/nippleRetractionProcessor";
import breastSkinChangesProcessor from "./Story Helpers/non standard element processors/breastSkinChangesProcessor";
import pigmentedSkinProcessor from "./Story Helpers/non standard element processors/pigmentedSkinProcessor";
import dermoscopyProcessor from "./Story Helpers/non standard element processors/dermoscopyProcesor";
import skinLesionProcessor from "./Story Helpers/non standard element processors/skinLesionProcessor";
import mskProcessor from "./Story Helpers/non standard element processors/mskProcessor";
import hoarsenessProcessor from "./Story Helpers/non standard element processors/hoarsenessProcessor";
import cnsProcessor from "./Story Helpers/non standard element processors/cnsProcessor";
import redReflexProcessor from "./Story Helpers/non standard element processors/redReflexProcessor";
import labTestProcessor from "./Story Helpers/non standard element processors/labTestProcessor";
import fitProcessor from "./Story Helpers/non standard element processors/fitProcessor";
import imagingProcessor from "./Story Helpers/non standard element processors/imagingProcessor";
import storyElements from "./Story Helpers/storyelements"
import itemTextTweaker from "./Story Helpers/itemTextTweaker";


const storyCore=
{
writeSymptomText: (extraSymptomDetails, melanomaSevenPoint, idaValues)=>
{
let newSymptomGroup = ""
let  newSymptomGroupForWrite =""
let paragraph = "The patient has "
let start=""
const endList=storyElements.endList
const middleList=storyElements.middleList
let elementsInGroup=0
let elementsInEachSentence=[]

let sentenceBeingWritten = -1
let sentenceIndex = -1

extraSymptomDetails.forEach(element => { 
    
//builds an array containging number of elements in each sentence
    if (newSymptomGroupForWrite !== element["symptomGroup"] )
        {
        sentenceIndex++
        elementsInGroup=0
        newSymptomGroupForWrite= element["symptomGroup"] 
        }
    
    elementsInGroup++
    elementsInEachSentence[sentenceIndex]=elementsInGroup
    })

extraSymptomDetails.forEach(element => {     
// iterates thogugh the input from all the questions related to a particular symptom
    elementsInEachSentence[sentenceBeingWritten]= elementsInEachSentence[sentenceBeingWritten]-1
    
    let beginning = ""
    let middle =""
    let end=""
    let sentence=""

     if (newSymptomGroup !== element["symptomGroup"] )
        {
        sentenceBeingWritten++
        newSymptomGroup= element["symptomGroup"] 
        switch (sentenceBeingWritten)
            {
            case 0:
            start= "" 
            break 
    
            case 1:
            start= "  They have" 
            break  
              
            case 2:
            start= "  Additionally they have" 
            break
            
            case 3:
            start= "  Furthermore they have" 
            break

            default:  
            start= "  They also have" 
            }
        }
       
// calls dedicated code modules for processing complex sentences.
    if (element.symptom === "Weight Loss")
        {
        sentence=weightLossProcessor(element)
        }

    else if (element.symptom === "Jaundice")
        {
        sentence=jaundiceProcessor(element)
        }

    else if (element.symptom === "Change in Bowel Habit")
        {
        sentence=cobhProcessor(element)
        }

    else if (element.symptom === "Change in testicular shape / texture")
        {
         sentence=testisProcessor(element)   
        }

    else if (element.symptom === 
        "Patient is /has been smoker")
        {
        sentence=smokingProcessor(element)   
        }   

    else if (element.symptom === "Asbestos exposure")
        {
        sentence=asbestosProcessor(element)   
        }

    else if (element.symptom === "Shortness of breath")
        {
        sentence=sobProcessor(element)   
        }

    else if (element.symptom === "Chest finding suggesting lung cancer")
        {
        sentence=chestExaminationProcessor(element)   
        }

    else if (element.symptom === "Unilateral nipple retraction")
        {
        sentence = nippleRetractionProcessor(element)
        }

    else if (element.symptom === "Skin changes suggesting breast cancer")
        {
        sentence = breastSkinChangesProcessor(element)
        }

    else if (element.symptom === "Pigmented skin lesion")
        {
        sentence = pigmentedSkinProcessor(element, melanomaSevenPoint)
        }

    else if (element.symptom === "Dermoscopy suggests melanoma")
        {
        sentence = dermoscopyProcessor(element)
        }

    else if (element.symptomGroup === "skinLesion" || element.symptomGroup === "skinNoSize" )
        {
        sentence = skinLesionProcessor(element)
        }

    else if (element.symptomGroup === "siteDescriptionDuration")
    {
    sentence = mskProcessor(element)
    }

    else if (element["symptom"] === "Unexplained hoarseness")
        {
        sentence = hoarsenessProcessor(element)
        }

    else if (element["symptom"] === 
    "CNS dysfunction")
    {
    sentence = cnsProcessor(element)
    }

    else if (element["symptom"] === 
    "Loss of red reflex (children)")
    {
    sentence = redReflexProcessor(element)
    }

    else if (element["symptomGroup"] === "labTestQuestions")
    {
    sentence = labTestProcessor(element,idaValues)
    }

    else if (element["symptomGroup"] ===  "fit")
    {
    sentence = fitProcessor(element)
    }

    else if (element["symptomGroup"] ===  "imagingQuestions")
    {
    sentence = imagingProcessor(element)
    }
// generic sentence constructor - uses itemTextTweaker to make small modifications to sentence elenents//

    else{

       

        for (let item in element)
            {
            if(typeof(element[item])!=="undefined" && (element[item])!=="" && element[item] !== null && item !== "symptomGroup")// skips empty items
                { 
                if (typeof(element[item]) !== "string" && typeof(element[item]) !== "number")// handles item generated by a checkbox group
                    {
                    if (!storyElements.skipParse.includes(item)) 
                        {
                        element[item]=arrayParser(element[item])
                        }
                    }

                let itemText=""
                if (!(/^-?\d+$/.test(element[item])) && typeof element[item] === 'string') //detect if doesn't start with lower case or is not a string and if so change to lower case
                        {
                        itemText=` ${element[item].toLowerCase()}`
                        }

                        else {itemText=` ${element[item]}`}


                itemText=itemTextTweaker(element, item, itemText)

                if (!endList.includes(item) && !middleList.includes(item)) // puts items at correct place in sentence
                        {
                        beginning += itemText
                        }
                    
                else if (!endList.includes(item))
                    {

                    middle += itemText
                    }

                else 
                    {
                  
                    end += itemText
                    }
                }
                sentence = beginning + middle + end
            }
        if (Object.keys(element).includes("Size_(cm)") && element["Size_(cm)"] ==="")
            {
            if (["a", "e", "i", "o", "u"].includes(sentence.trimStart().slice(0,1)))
                {
                start += " an"
                }
            else 
                {
                start += " a"
                }
            }  
        else if (storyElements.a_list.includes(element["symptom"]))
        {
        start += " a"   
        }
    }
      
    let ender=""
    if (elementsInEachSentence[sentenceBeingWritten]===1 )
        {
        ender = "."
        }
    else
        {
        ender=(elementsInEachSentence[sentenceBeingWritten]>2 ? ": " : " and")
        }

        sentence += ender
                
            
 paragraph += start
       paragraph += sentence 
       sentence=""
       start=""
});

return (paragraph)
}
}

export default storyCore